// src/components/Loader.js
import React from "react";
import { Spinner } from "react-bootstrap";
import { useLoader } from "../context/LoaderContext";

const Loader = () => {
  const { loading } = useLoader();

  if (!loading) return null; // hide when not loading

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(255,255,255,0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
      }}
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default Loader;
